export enum EnumProperties {
  KEY = 'key',
  NAME = 'name',
  DISPLAY_TEXT = 'displayText',
}
